// Put your application javascript here
var nextUntil = function (elem, selector, filter) {
  var siblings = [];
  elem = elem.nextElementSibling;
  while (elem) {
    if (elem.matches(selector)) break;
    if (filter && !elem.matches(filter)) {
      elem = elem.nextElementSibling;
      continue;
    }
    siblings.push(elem);
    elem = elem.nextElementSibling;
  }
  return siblings;
}

function wrap(wrapper, elms) {
  if (!elms.length) {
    elms = [elms];
  }
  for (var i = elms.length - 1; i >= 0; i--) {
    var child = (i > 0) ? wrapper.cloneNode(true) : wrapper;
    var el = elms[i];
    var parent = el.parentNode;
    var sibling = el.nextSibling;
    child.appendChild(el);
    if (sibling) {
      parent.insertBefore(child, sibling);
    } else {
      parent.appendChild(child);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  function reloadHTML(html, selector) {
    var temp = document.createElement('DIV')
    temp.innerHTML = html
    const el = temp.querySelector(selector);
    ;[...document.querySelectorAll(selector)].forEach(i => {
      i.innerHTML = el.outerHTML
    })
    temp.innerHTML = ''
  }

  async function reloadCart() {
    const r = await fetch('/cart', {
      credentials: 'include',
      method: 'GET'
    })
    const response = await r.text()

    reloadHTML(response, '.cart-counter')
    reloadHTML(response, '.checkout')
  }
  reloadCart()

  var prevScrollpos = window.pageYOffset;
  var delta = 20;
  window.onscroll = function() {
    var currentScrollPos = window.pageYOffset;
    if (Math.abs(prevScrollpos - currentScrollPos) <= delta) return
    if (currentScrollPos > 360 && prevScrollpos > currentScrollPos) {
      document.body.classList.add('reveal-fixed-header')
    } else {
      document.body.classList.remove('reveal-fixed-header')
    }
    prevScrollpos = currentScrollPos;
  }

  document.body.addEventListener('submit', async function(e) {
    if (e.target.matches('.add-to-cart')) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      let properties = {}
      let cartObj = Object.fromEntries(new FormData(e.target))
      const props = Object.entries(cartObj).forEach(([key, value]) => {
        if (key.indexOf('properties[') > -1 && value.length > 0) {
          if (key.indexOf('shipping') > -1) return
          properties[key.match(/\[(.*?)\]/)[1]] = value
        }
      })
      cartObj.properties = properties

      const r = await fetch('/cart/add.js', {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify(cartObj),
        method: 'POST'
      })
      const response = await r.text()

      if (response.toLowerCase().indexOf('error') > -1) {
        var json = JSON.parse(response)
        document.querySelector('.add-to-cart__message').innerHTML = 
          `<h1>Oops! ${json['description']}</h1>`
        document.body.classList.add('show--error')
        document.body.classList.remove('cart--in-progress')
        clearInterval(window.timerObj)
        window.timerObj = setTimeout(function() {
          document.body.classList.remove('show--error')
          //document.querySelector('.add-to-cart__message').innerHTML = ''
        }, 4 * 1000)
      } else {
        await reloadCart()
        // document.querySelector('.add-to-cart__success').innerHTML = 
        //   `<h3>Notification</h3>
        //    <p>Successfully added.</p>`
        document.body.classList.add('show--success')
        document.body.classList.remove('cart--in-progress')
        document.documentElement.classList.remove('open--product')
        clearInterval(window.timerObj)
        window.timerObj = setTimeout(function() {
          document.body.classList.remove('show--success')
          //document.querySelector('.add-to-cart__success').innerHTML = ''
        }, 4 * 1000)
      }
    }
  })

  document.body.addEventListener('change', async function(e) {
    if (e.target.matches('.item-quantity')) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch('/cart/change.js?line='+e.target.getAttribute('data-line')+'&quantity='+e.target.value, {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      await reloadCart()
      document.body.classList.remove('cart--in-progress')
    }
    if (e.target.matches('[name="for_toggle"]')) {
      const value = document.querySelector('input[name="for_toggle"]:checked').value
      if (value == 'someone-else') {
        document.body.classList.add('show--someone-else')
        ;[...document.querySelectorAll(".someone-else input")].forEach(i => i.disabled = false)
      } else {
        document.body.classList.remove('show--someone-else')
        ;[...document.querySelectorAll('.someone-else input')].forEach(i => i.disabled = true)
      }
    }
  })

  document.body.addEventListener('keydown', async function(e) {
    if (e.target.matches('.search-tiles')) {
      var code = String.fromCharCode(event.keyCode);
      if (/[a-zA-Z0-9-_ ]/.test(code) || event.keyCode == 8) {
        document.querySelector('.search-tiles__clone').classList.add('hide')
      }
    }
  })

  document.body.addEventListener('keyup', async function(e) {
    if (e.target.matches('.search-tiles')) {
      var val = new RegExp(e.target.value.replace(' ', '.*'), 'i')
      document.querySelector('.search-tiles__clone span').innerHTML = e.target.value
      ;[].forEach.call(document.querySelectorAll('.product-tile'), function(el) {
        if (!val.test(el.innerText)) {
          el.classList.add('hide')
        } else {
          el.classList.remove('hide')
        }
      })
      var count = document.querySelectorAll('.product-tile:not(.hide)').length
      if (e.target.value.length > 0) {
        document.body.className = document.body.className.replace(/show--\S+/g, '')
        if (count !== +document.querySelector('.search-tiles__clone sup').innerHTML) {
          document.querySelector('.search-tiles__clone sup').innerHTML = count
        }
      } else {
        document.querySelector('.search-tiles__clone sup').innerHTML = ''
      }
      document.querySelector('.search-tiles__clone').classList.remove('hide')
    }
  })

  document.body.addEventListener('click', async function(e) {
    if (e.target.matches('.section-groups h2')) {
      [...document.querySelectorAll('.active-group')].forEach(function(el) {
        el.classList.remove('active-group')
      })
      e.target.classList.add('active-group')
      ;[...(document.querySelectorAll('[data-toggle="'+e.target.getAttribute('data-parent-toggle')+'"]'))].forEach(function(el, i) {
        el.classList.add('active-group')
        if (i == 0) {
          el.querySelector('.faq').classList.add('faq-active')
        } else {
          el.querySelector('.faq').classList.remove('faq-active')
        }
      })
    }

    if (e.target.matches('.faq-question')) {
      /*
      if (e.target.parentNode.matches('.faq-active')) {
        e.target.parentNode.classList.remove('faq-active')
      } else {
      */
        [...document.querySelectorAll('.faq-active')].forEach(function(el) {
          el.classList.remove('faq-active')
        })
        e.target.parentNode.classList.add('faq-active')
      /*
      }
      */
    }

    if (e.target.matches('.collection-filter a')) {
      e.preventDefault()
      document.body.className = document.body.className.replace(/show--\S+/g, '')
      document.body.classList.add('show--'+e.target.getAttribute('data-collection'))
      var search = document.querySelector('.search-tiles')
      search.value = ''
      search.dispatchEvent(new Event('keyup', { bubbles: true }))
    }

    if (e.target.matches('.decrement')) {
      e.preventDefault()
      var input = e.target.parentNode.querySelector('input')
      input.value = +(Math.max(1, input.value)) - 1
      if (document.documentElement.classList.contains('open--cart')) {
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }
    if (e.target.matches('.increment')) {
      e.preventDefault()
      var input = e.target.parentNode.querySelector('input')
      input.value = +(input.value) + 1
      if (document.documentElement.classList.contains('open--cart')) {
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }
    if (e.target.matches('.open-primary-menu')) {
      e.preventDefault()
      document.body.classList.remove('open--secondary-menu')
    }
    else if (e.target.matches('.remove-link')) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      try {
        const r = await fetch(e.target.href.replace('change', 'change.js'), {
          credentials: 'include',
          headers: {
            'content-type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'xmlhttprequest'
          },
          method: 'GET'
        })
        const response = await r.text()
        await reloadCart()
        document.body.classList.remove('cart--in-progress')
      } catch (e) {
        document.location.reload()
      }
    }
  })

  /*
  ;[].forEach.call(document.querySelectorAll('.remove-link'), function(el) {
    el.addEventListener('click', async function(e) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch(this.href.replace('change', 'change.js'), {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      reloadCart()
      document.body.classList.remove('cart--in-progress')
    })
  })
  */

  function activateProductGallery() {
    var glide = new Glide('.product-glide', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      gap: 0
    }).mount()
  }

  if (document.querySelector('.product-glide')) {
    activateProductGallery()
  }

  initSourcingAccordion();

  ;[].forEach.call(document.querySelectorAll('.product-tile a'), function(el) {
    el.addEventListener('click', async function(e) {
      e.preventDefault()

      const r = await fetch(this.href, {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      var temp = document.createElement('DIV')
      temp.innerHTML = response
      var content = temp.querySelector('.product-details')
      document.querySelector('.product-wrapper').innerHTML = content.innerHTML
      document.querySelector('.product__inner').scrollTop = 0
      document.documentElement.classList.add('open--product')
      delete temp

      activateProductGallery()

      initSourcingAccordion(document.querySelector('.product-wrapper'));

    })
  })

  if (window.innerWidth > 680) {
  ;[].forEach.call(document.querySelectorAll('.section-faqs h2'), function(el) {
    var faqBlock = nextUntil(el, 'h2')
    var wrapper = document.createElement('div')
    wrapper.className = 'faq-block'
    wrapper.setAttribute('data-toggle', el.innerText)
    wrap(wrapper, faqBlock)
    el.setAttribute('data-parent-toggle', el.innerText)
    document.querySelector('.section-groups').appendChild(el)
  })
  if (document.querySelector('.section-groups h2')) {
    document.querySelector('.section-groups h2').dispatchEvent(new Event('click', { bubbles: true }))
  }

  const firstActiveFaq = document.querySelector('.faq.faq-active');
  if (firstActiveFaq) {
    firstActiveFaq.classList.remove('faq-active');
  }
}

}, false)

function initSourcingAccordion(scope) {
  scope = scope || document;
  var desc = scope.querySelector('.description');
  if (!desc || desc.querySelector('details.sourcing-accordion')) return;

  function isHeadingPara(p) {
    var b = p.querySelector('b, strong');
    if (!b) return false;
    var t = p.textContent.trim();
    return t.length > 0 && t === b.textContent.trim();
  }

  var paras = Array.prototype.slice.call(desc.children);
  var headingIndexes = [];
  paras.forEach(function (p, i) {
    if (isHeadingPara(p)) headingIndexes.push(i);
  });
  if (!headingIndexes.length) return;

  headingIndexes.forEach(function (startIndex, idx) {
    var heading = paras[startIndex];
    var endIndex = idx + 1 < headingIndexes.length ? headingIndexes[idx + 1] : paras.length;
    var content = paras.slice(startIndex + 1, endIndex);

    var details = document.createElement('details');
    details.className = 'sourcing-accordion';
    var summary = document.createElement('summary');
    summary.textContent = heading.textContent.trim();
    details.appendChild(summary);
    content.forEach(function (p) { details.appendChild(p); });
    heading.replaceWith(details);
  });
}